import { render, staticRenderFns } from "./LearningAmountMenu.vue?vue&type=template&id=670e6b8e&"
import script from "./LearningAmountMenu.vue?vue&type=script&lang=js&"
export * from "./LearningAmountMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports